<template>
  <div id="myElement" style="position: absolute; width: 100%; height: 100%; top: 0; background: #f0f3f7">
    <div class="digSHowBox" v-if="carmerShow">
      <div class="cameraBox">
        <div style="" class="box1">人脸认证核验</div>
        <div class="box2">为保证考试严肃，需本人进行人脸认证核验后才能继续考试学习</div>
        <div style="" class="bkBox box3">
          <div class="bk">
            <img class="box4" src="../../assets/examImgs/bk.png" alt="" />
          </div>
          <img v-if="showImg" :src="imgUrl" alt="" class="box5" />
          <video v-if="!showImg" class="box23" id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
          <canvas id="canvasCamera" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()" class="camerBtn">立即认证核验</div>
      </div>
    </div>

    <div class="header">
      <!-- <div
        @click="goBack"
        style="
          background: rgba(255, 255, 255, 0.15);
          width: 80px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          margin-top: 10px;
          border-radius: 30px;
          text-align: center;
        "
      >
        返回
      </div> -->
      <div></div>
      <div class="time">题库练习</div>

      <div style="display: flex">
        <div>{{ examInfo.userName }}</div>
        <div style="" class="box6"></div>
      </div>
    </div>

    <div class="examBanner">
      <div class="examLeft">
        <div class="scollBox box8" style="">
          <div style="" class="box9">
            <div style="" class="box10"></div>

            <div style="" class="box11">题目列表</div>
          </div>

          <div class="box12" v-for="msg in examData" :key="msg.type">
            <!-- 单选题 -->
            <div v-if="msg.qType == '0501'">
              <div class="box13">单选题（共{{ timuList.length }}题，合计{{ timuList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in timuList"
                  :key="item.id"
                  :class="item.z ? 'color7 box14' : swiperIndex == index && !item.z ? 'color5 box14' : 'color6 box14'"
                  @click="toSn(index)"
                >
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 单选题end -->
            <!-- 多选题 -->
            <div class="box15" v-if="msg.qType == '0502'">
              <div class="box13">多选题（共{{ timuList.length }}题，合计{{ timuList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in timuList"
                  :key="item.id"
                  :class="item.z ? 'color7 box14' : swiperIndex == index && !item.z ? 'color5 box14' : 'color6 box14'"
                  @click="toSn(index)"
                >
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 多选题end -->
            <!-- 判断题 -->
            <div class="box15" v-if="msg.qType == '0503'">
              <div class="box13">判断题（共{{ timuList.length }}题，合计{{ timuList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in timuList"
                  :key="item.id"
                  :class="item.z ? 'color7 box14' : swiperIndex == index && !item.z ? 'color5 box14' : 'color6 box14'"
                  @click="toSn(index)"
                >
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 判断题end -->
            <!-- 简答题 -->
            <div class="box15" v-if="msg.qType == '0504'">
              <div class="box13">简答题（共{{ jiandaList.length }}题，合计{{ jiandaList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in jiandaList"
                  :key="item.id"
                  :class="
                    item.z
                      ? 'color7 box14'
                      : swiperIndex == timuList.length + timuList.length + +timuList.length + index && !item.z
                      ? 'color5 box14'
                      : 'color6 box14'
                  "
                  @click="toSn(timuList.length + timuList.length + timuList.length + index)"
                >
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 简答题end -->

            <!-- 阅读理解题 -->
            <div class="box15" v-if="msg.qType == '0506'">
              <div class="box13">阅读理解题（共{{ shicaoList.length }}题，合计{{ shicaoList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in shicaoList"
                  :key="item.id"
                  :class="
                    item.z
                      ? 'color7 box14'
                      : swiperIndex == timuList.length + timuList.length + +timuList.length + jiandaList.length + index && !item.z
                      ? 'color5 box14'
                      : 'color6 box14'
                  "
                  @click="toSn(timuList.length + timuList.length + timuList.length + jiandaList.length + index)"
                >
                  {{ timuList.length + timuList.length + timuList.length + jiandaList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 阅读理解题end -->
          </div>
        </div>
        <div class="optionTips">
          <div class="yuan box24"></div>
          <div class="box16">未答</div>
          <div class="yuan box25" style="background: #5ad068"></div>
          <div class="box16">进行</div>
          <div class="yuan box25" style="background: #4275f5"></div>
          <div class="box16">已答</div>
        </div>
      </div>
      <!-- 题目选项模块 -->
      <div class="examCenter">
        <swiper id="swiper" ref="mySwiper" class="swiper swiper-no-swiping">
          <swiper-slide>
            <!-- 单选题 -->
            <div v-if="queType == '0501'" style="display: flex">
              <div class="timu">
                <div class="titleTips">单选题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18" :key="num">
                  <div
                    @click="onSelet(idx, data.id)"
                    v-for="(data, idx) in tiMuInfo.optionList"
                    :key="data.id"
                    :class="
                      data.selected && tiMuInfo.class
                        ? 'SucceseletXuan xuan'
                        : data.selected && !tiMuInfo.class
                        ? 'errSeletXuan xuan'
                        : 'xuan'
                    "
                  >
                    <div class="xxBox">
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div v-if="data.selected && tiMuInfo.class">
                        <img class="seImg" src="../../assets/examImgs/dui@2x.png" alt="" />
                      </div>
                      <div v-if="data.selected && !tiMuInfo.class">
                        <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                      </div>
                    </div>

                    <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>

                <div :key="numKey">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx" :key="numKey">
                    <div>
                      正确答案：{{
                        tiMuInfo.asw == '0'
                          ? 'A'
                          : tiMuInfo.asw == '1'
                          ? 'B'
                          : tiMuInfo.asw == '2'
                          ? 'C'
                          : tiMuInfo.asw == '3'
                          ? 'D'
                          : tiMuInfo.asw == '4'
                          ? 'E'
                          : tiMuInfo.asw == '5'
                          ? 'F'
                          : tiMuInfo.asw == '6'
                          ? 'G'
                          : 'H'
                      }}
                    </div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>

            <!-- 判断 -->
            <div v-if="queType == '0503'" style="display: flex">
              <div class="timu">
                <div class="titleTips">判断题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18" :key="num">
                  <div
                    @click="onPanSelet(idx)"
                    v-for="(data, idx) in tiMuInfo.optionList"
                    :key="idx"
                    :class="
                      data.selected && tiMuInfo.class
                        ? 'SucceseletXuan xuan'
                        : data.selected && !tiMuInfo.class
                        ? 'errSeletXuan xuan'
                        : 'xuan'
                    "
                  >
                    <div class="xxBox">
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div v-if="data.selected && tiMuInfo.class">
                        <img class="seImg" src="../../assets/examImgs/dui@2x.png" alt="" />
                      </div>
                      <div v-if="data.selected && !tiMuInfo.class">
                        <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div :key="numKey">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx">
                    <div>正确答案：{{ tiMuInfo.answers == '01' ? '对' : '错' }}</div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi()">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>

            <!-- 多选题 -->
            <div v-if="queType == '0502'" style="display: flex">
              <div class="timu">
                <div class="titleTips">多选题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18">
                  <div v-for="(data, idx) in tiMuInfo.optionList" :key="data.id">
                    <div
                      @click="onDuoSelet(idx)"
                      :key="num"
                      :class="
                        data.selected && tiMuInfo.class
                          ? 'SucceseletXuan xuan'
                          : data.selected && !tiMuInfo.class
                          ? 'errSeletXuan xuan'
                          : 'xuan'
                      "
                    >
                      <div class="xxBox">
                        <div class="box25">
                          <span style="font-family: Bold">{{
                            idx == 0
                              ? 'A'
                              : idx == 1
                              ? 'B'
                              : idx == 2
                              ? 'C'
                              : idx == 3
                              ? 'D'
                              : idx == 4
                              ? 'E'
                              : idx == 5
                              ? 'F'
                              : idx == 6
                              ? 'G'
                              : idx == 7
                              ? 'H'
                              : 'I'
                          }}</span
                          >&emsp;{{ data.opContent }}
                        </div>
                        <div v-if="data.selected && tiMuInfo.class">
                          <img class="seImg" src="../../assets/examImgs/dui@2x.png" alt="" />
                        </div>
                        <div v-if="data.selected && !tiMuInfo.class">
                          <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                        </div>
                      </div>
                      <div class="box17" v-for="(img, idx) in data.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div :key="numKey">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx" :key="numKey">
                    <div>
                      正确答案：<span v-for="(cc, cidx) in tiMuInfo.asw" :key="cidx">
                        <span v-if="cc !== ','">
                          {{
                            cc == '0'
                              ? 'A'
                              : cc == '1'
                              ? 'B'
                              : cc == '2'
                              ? 'C'
                              : cc == '3'
                              ? 'D'
                              : cc == '4'
                              ? 'E'
                              : cc == '5'
                              ? 'F'
                              : cc == '6'
                              ? 'G'
                              : 'H'
                          }}
                        </span>
                      </span>
                    </div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi()">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- 题目选项模块end -->
      <div class="examRight">
        <div class="box30">
          <div class="box31">
            <div class="box32"></div>

            <div class="box33">刷题小知识</div>
          </div>

          <div class="box34">
            <div class="fs">
              <div>
                本系统收录的 [{{ timuList.length }}] 道题，旨在系统化构建你的知识体系。你的目标不是“刷完”，而是“掌握”。
                <div>1道经典题 + 3 次复习 > 3 道新题只做1次。</div>
                <div>不要急于完成：面对新题，请给自己至少15分钟的独立思考时间。</div>
                <div>无论对错，都在笔记中记录：核心思路、卡点、时间/空间复杂度。</div>
                <div>每题都有讨论区与官方题解，但请先思考，后参考。</div>
              </div>
            </div>

            <!-- <div v-if="isSign !== '01'"
                 class="qd">
              <div style="display: flex">
                <div>
                  <img class="box35"
                       src="../../assets/examImgs/qiandao@2x.png"
                       alt="" />
                </div>

                <div class="box39">已签到</div>
              </div>
            </div>

            <div v-else
                 class="qd"
                 style="background: #fe5f5e;"
                 @click="onQd">
              <div style="display: flex">
                <div>
                  <img class="box35"
                       src="../../assets/examImgs/qiandao@2x.png"
                       alt="" />
                </div>

                <div class="box39">签到</div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="box36">
          <div class="box31">
            <div class="box32"></div>

            <div class="box33">温馨提示</div>
          </div>

          <div class="box37">
            <div>如您需要记录刷题位置，请点击下方的“记题续答”按钮记录。</div>
            <div style="color: #666666; font-size: 13px">（下次再次进入将会从此题开始）</div>
            <div class="jtBtn" @click="record">记题续答</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
import { Loading } from 'element-ui';
import { getQuestionList, getQuestionOffset, doSaveQuestionOffset, recordPracticeMistake } from '../../api/study';
// Import Swiper styles
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examData: [], //题目数据
      swiperIndex: 0, //当前页面的题目索引
      num: 0, //key值重置
      jiandaList: [], //简答题
      shicaoList: [], //阅读理解,阅读理解
      videoWidth: 170,
      videoHeight: 170,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      showImg: false, //截图的图片
      carmerShow: false, //人脸识别组件
      examInfo: {}, //试卷数据
      timeimit: 0, //倒计时
      time: '', //倒计时
      interval: null, //定时器
      isSign: '01', //签到状态
      percentageNum: 0, //已做
      totleNum: 0, //总数
      handInTimer: null, //定时器
      findTimer: null,
      webSocket: null,
      surl: '',
      setIntervalWesocketPush: null, //定时器
      dialogVisible: false,
      isFullScreen: false,
      numKey: 110,
      tiMuInfo: {}, //题目的数据
      queType: '', //练习题类型
      timuList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //获取记录
    getQuestionOffset() {
      let data = {
        qtypeId: this.$route.query.qtypeId,
        orderId: this.$route.query.orderId
      };
      getQuestionOffset(data).then(res => {
        this.swiperIndex = res.data.data;
        this.tiMuInfo = this.timuList[res.data.data];
      });
    },
    //记题续答
    record() {
      this.$confirm('确定要记录该题位置吗？（下次刷题将从此题开始）', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let data = {
            qtypeId: this.$route.query.qtypeId,
            offset: this.swiperIndex < 0 ? 0 : this.swiperIndex,
            orderId: this.$route.query.orderId
          };
          doSaveQuestionOffset(data).then(res => {
            console.log(res);
            this.$message.success('记录成功！');
          });
        })
        .catch(() => {});
    },
    lookDa() {
      this.tiMuInfo.dajx = true;
      this.numKey = this.numKey + 1;
    },
    //
    goBack() {
      // let data = {
      //   qtypeId: this.$route.query.qtypeId,
      //   offset: this.swiperIndex < 0 ? 0 : this.swiperIndex,
      //   orderId: this.$route.query.orderId
      // };
      // doSaveQuestionOffset(data).then(res => {
      //   console.log(res);
      // });
      this.$router.back();
    },
    //输入框不能输入的bug
    oninpus(e) {
      this.$forceUpdate();
      //console.log(e);
    },
    //处理考试进度百分比
    percentage() {
      this.totleNum = this.timuList.length + this.timuList.length + +this.timuList.length + this.jiandaList.length + this.shicaoList.length;
    },
    //单选题选择选项
    onSelet(idx, id) {
      this.timuList[this.swiperIndex].z = true;
      this.timuList[this.swiperIndex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      let lsl = {
        questionId: this.tiMuInfo.id,
        answer: id,
        classCodeId:this.$route.query.classCodeId
      };
      if (this.timuList[this.swiperIndex].asw == idx) {
        //选对了
        this.timuList[this.swiperIndex].class = true;
        lsl.isCorrect = '02';
        recordPracticeMistake(lsl).then(res => {});
      } else {
        this.timuList[this.swiperIndex].class = false;
        lsl.isCorrect = '01';
        recordPracticeMistake(lsl).then(res => {});
      }
      this.num = this.num + 1;
    },

    //多选题选择选项
    onDuoSelet(idx) {
      let usw = [];
      let ids = [];
      if (this.timuList[this.swiperIndex].optionList[idx].selected) {
        this.timuList[this.swiperIndex].optionList[idx].selected = false;
        this.timuList[this.swiperIndex].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.timuList[this.swiperIndex].optionList.forEach((v, vx) => {
          if (v.selected) {
            usw.push(vx);
            ids.push(v.id);
          }
        });
        let lsl = {
          questionId: this.tiMuInfo.id,
          answer: ids.toString(),
        classCodeId:this.$route.query.classCodeId
        };
        if (usw.toString() == this.tiMuInfo.asw) {
          lsl.isCorrect = '02';
          this.timuList[this.swiperIndex].class = true;
          recordPracticeMistake(lsl).then(res => {});
        } else {
          lsl.isCorrect = '01';
          this.timuList[this.swiperIndex].class = false;
          recordPracticeMistake(lsl).then(res => {});
        }
        this.num = this.num + 1;

        return false;
      }
      this.timuList[this.swiperIndex].z = true;

      this.timuList[this.swiperIndex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.timuList[this.swiperIndex].optionList.forEach((v, vx) => {
        if (v.selected) {
          usw.push(vx);
          ids.push(v.id);
        }
      });
      let lsl = {
        questionId: this.tiMuInfo.id,
        answer: ids.toString(),
        classCodeId:this.$route.query.classCodeId
      };
      if (usw.toString() == this.tiMuInfo.asw) {
        lsl.isCorrect = '02';
        this.timuList[this.swiperIndex].class = true;
        recordPracticeMistake(lsl).then(res => {});
      } else {
        lsl.isCorrect = '01';
        this.timuList[this.swiperIndex].class = false;
        recordPracticeMistake(lsl).then(res => {});
      }
      this.num = this.num + 1;
    },
    //判断题选择选项
    onPanSelet(idx) {
      let lsl = {
        questionId: this.tiMuInfo.id,
        answer: idx == 0 ? '01' : '00',
        classCodeId:this.$route.query.classCodeId
      };
      this.timuList[this.swiperIndex].z = true;
      this.timuList[this.swiperIndex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      console.log(this.tiMuInfo);

      let daAn = this.tiMuInfo.answers == '01' ? 0 : 1;
      if (idx == daAn) {
        //选对了
        this.timuList[this.swiperIndex].class = true;
        lsl.isCorrect = '02';
        recordPracticeMistake(lsl).then(res => {});
      } else {
        this.timuList[this.swiperIndex].class = false;
        lsl.isCorrect = '01';
        recordPracticeMistake(lsl).then(res => {});
      }
      this.num = this.num + 1;
    },
    //阅读理解子单选题选项
    onzSelet(index, cindex, idx) {
      //console.log(index, cindex, idx);
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_1[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //阅读理解子多选题选择选项
    onzDuoSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;
      if (this.shicaoList[index].subList_2[cindex].optionList[idx].selected) {
        this.shicaoList[index].subList_2[cindex].optionList[idx].selected = false;
        this.shicaoList[index].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_2[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.num = this.num + 1;
    },
    //题目列表点击事件
    toSn(idx) {
      //console.log(idx);
      this.swiperIndex = idx;
      if (this.queType == '0501') {
        //单选题
        //console.log(this.timuList[idx]);
        this.tiMuInfo = this.timuList[idx];
      } else if (this.queType == '0502') {
        //多选
        //console.log(this.timuList[idx]);
        this.tiMuInfo = this.timuList[idx];
      } else if (this.queType == '0503') {
        //判断
        //console.log(this.timuList[idx]);
        this.tiMuInfo = this.timuList[idx];
      }

      // this.$refs.mySwiper.swiperInstance.slideTo(idx);
      // this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
    },
    //上一题
    upTi() {
      if (this.swiperIndex !== 0) {
        this.swiperIndex = this.swiperIndex - 1;
      }
      if (this.queType == '0501') {
        //单选题
        //console.log(this.timuList[this.swiperIndex]);
        this.tiMuInfo = this.timuList[this.swiperIndex];
      } else if (this.queType == '0502') {
        //多选
        //console.log(this.timuList[this.swiperIndex]);
        this.tiMuInfo = this.timuList[this.swiperIndex];
      } else if (this.queType == '0503') {
        //判断
        //console.log(this.timuList[this.swiperIndex]);
        this.tiMuInfo = this.timuList[this.swiperIndex];
      }
      if (this.tiMuInfo.z) {
        this.percentageNum = this.percentageNum + 1;
      }
      window.scrollTo(0, 0);
    },
    //下一题
    dowTi() {
      if (this.queType == '0501') {
        //单选题
        if (this.swiperIndex !== this.timuList.length - 1) {
          this.swiperIndex = this.swiperIndex + 1;
        }
        this.tiMuInfo = this.timuList[this.swiperIndex];
      } else if (this.queType == '0502') {
        //多选
        if (this.swiperIndex !== this.timuList.length - 1) {
          this.swiperIndex = this.swiperIndex + 1;
        }
        this.tiMuInfo = this.timuList[this.swiperIndex];
      } else if (this.queType == '0503') {
        //判断
        if (this.swiperIndex !== this.timuList.length - 1) {
          this.swiperIndex = this.swiperIndex + 1;
        }
        this.tiMuInfo = this.timuList[this.swiperIndex];
      }
      if (this.tiMuInfo.z) {
        this.percentageNum = this.percentageNum + 1;
      }
      window.scrollTo(0, 0);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let loadingInstance = Loading.service({
      lock: true,
      text: '题目加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, .2)'
    });

    let data = {
      codeId: this.$route.query.codeId,
      qtypeId: this.$route.query.qtypeId,
      qtypeName:this.$route.query.qtypeName
    };
    let _this = this;
    //题目接口数据
    getQuestionList(data).then(res => {
      _this.examData = [];
      //处理数据
      if (_this.$route.query.qtypeName == '单选') {
        _this.queType = '0501';
        let data = {
          qType: '0501'
        };
        _this.examData.push(data);
        _this.timuList = res.data.data;
        _this.timuList.forEach(v => {
          //分割图片和题目
          let arr = v.content.split('*');
          v.content = arr[0];
          arr.splice(0, 1);
          arr.splice(arr.length - 1, 1);
          v.images = arr;
          if (v.z) {
            _this.percentageNum = _this.percentageNum + 1;
          }
          v.optionList.forEach(x => {
            let ass = x.opContent.split('*');
            x.opContent = ass[0];
            ass.splice(0, 1);
            ass.splice(ass.length - 1, 1);
            x.images = ass;
          });
        });
      }

      if (_this.$route.query.qtypeName == '多选') {
        _this.queType = '0502';
        let data = {
          qType: '0502'
        };
        _this.examData.push(data);
        _this.timuList = res.data.data;
        _this.timuList.forEach(v => {
          let arr = v.content.split('*');
          v.content = arr[0];
          arr.splice(0, 1);
          arr.splice(arr.length - 1, 1);
          v.images = arr;
          if (v.z) {
            _this.percentageNum = _this.percentageNum + 1;
          }
          v.optionList.forEach(x => {
            let ass = x.opContent.split('*');
            x.opContent = ass[0];
            ass.splice(0, 1);
            ass.splice(ass.length - 1, 1);
            x.images = ass;
          });
        });
      }

      if (_this.$route.query.qtypeName.includes('判断')) {
        _this.queType = '0503';
        let data = {
          qType: '0503'
        };
        _this.examData.push(data);
        _this.timuList = res.data.data;
        _this.timuList.forEach(v => {
          let arr = v.content.split('*');
          v.content = arr[0];
          arr.splice(0, 1);
          arr.splice(arr.length - 1, 1);
          v.images = arr;
          if (v.z) {
            _this.percentageNum = _this.percentageNum + 1;
          }
          if (v.userAnswer) {
            if ((v.answers = '00')) {
              v.optionList = [
                {
                  opContent: '对',
                  selected: true
                },
                {
                  opContent: '错',
                  selected: false
                }
              ];
            } else if ((v.answers = '01')) {
              v.optionList = [
                {
                  opContent: '对',
                  selected: false
                },
                {
                  opContent: '错',
                  selected: true
                }
              ];
            }
          } else {
            v.optionList = [
              {
                opContent: '对',
                selected: false
              },
              {
                opContent: '错',
                selected: false
              }
            ];
          }
        });
      }
      loadingInstance.close();
      this.getQuestionOffset();
    });
  },
  destroyed() {},
  beforeDestroy() {
    //销毁定时器
    clearTimeout(this.setIntervalWesocketPush);
    clearInterval(this.handInTimer);
    clearInterval(this.findTimer);
    clearInterval(this.interval);
    this.handInTimer = null;
    this.findTimer = null;
    this.interval = null;
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.xxBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  .seImg {
    margin-top: 6px;
    width: 24px;
    height: 24px;
  }
}
.dajxBox {
  width: 480px;
  height: 210px;
  overflow-y: auto;
  color: #5ad068;
  padding: 10px;
  background: rgba(90, 208, 104, 0.1);
  border-radius: 5px;
  font-size: 16px;
  font-family: Medium;
  margin-bottom: 5px;
}
.dajxBox::-webkit-scrollbar {
  width: 4px;
}
.dajxBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.dajxBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.dajx {
  // margin-bottom: 200px;
  border-radius: 5px;
  width: 480px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #4275f5;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.dia {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  font-size: 16px;
  font-family: Regular;
}
.qBtn {
  width: 180px;
  height: 50px;
  background: #4275f5;
  opacity: 1;
  border-radius: 25px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  line-height: 50px;
  margin: 23px auto auto auto;
}
.box1 {
  font-family: Bold;
  font-size: 18px;
  text-align: center;
}
.box2 {
  margin-top: 8px;
}
.box3 {
  margin-top: 28px;
}
.box4 {
  width: 171px;
  height: 171px;
}
.box5 {
  width: 170px;
  height: 170px;
}
.box6 {
  margin-top: 11px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
}
.box7 {
  margin-left: 10px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  opacity: 1;
}
.box8 {
  height: 698px;
  overflow-y: auto;
}
.box9 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box10 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box11 {
  margin-left: 8px;
}
.box12 {
  margin-top: 24px;
  font-family: Medium;
}
.box13 {
  color: #333333;
  font-size: 15px;
}
.box14 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin: 10px 10px 0 0;
}
.box15 {
  margin-top: 24px;
  font-family: Medium;
}
.box16 {
  margin-left: 5px;
}

.box17 {
  margin: 10px auto auto auto;
}
.box18 {
  height: 510px;
  overflow-y: auto;
}
.box19 {
  width: 480px;
}
.box20 {
  height: 220px;
}
.box21 {
  color: #fff;
  background: #507df7;
  border: 0;
  margin-left: 50px;
}
.box22 {
  padding: 5px;
  font-size: 16px;
  color: #272748;
  width: 100%;
  height: auto;
}
.box23 {
  border-radius: 12px;
}
.box24 {
  background: #f1f3f7;
  margin-left: 13px;
}
.box25 {
  margin-left: 12px;
}

.box26 {
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.box27 {
  margin: 0px 5px;
}
.box28 {
  height: 700px;
  overflow-y: auto;
  width: 494px;
}
.box29 {
  font-size: 16px;
  font-family: Regular;
  margin-bottom: 10px;
}
.box30 {
  height: 540px;
  background: #fff;
  padding: 28px 20px;
  border-radius: 12px;
}
.box31 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box32 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box33 {
  margin-left: 8px;
}
.box34 {
  margin-top: 20px;
}
.box35 {
  width: 16px;
  height: 16px;
}
.box36 {
  margin-top: 10px;
  width: 240px;
  height: 300px;
  background: #ffffff;
  border-radius: 12px;
  padding: 28px 20px;
}
.box37 {
  margin-top: 24px;
  font-family: Medium;
  font-size: 14px;
  .jtBtn {
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    background: #f56642;
    border-radius: 12px;
    color: #fff;
    cursor: pointer;
    margin: 30px auto auto auto;
  }
}
.box38 {
  width: 16px;
  height: 16px;
  margin-top: 4px;
}
.box39 {
  margin-left: 4px;
}

.box47 {
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.box48 {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
}
.box49 {
  text-align: center;
  font-size: 18px;
  font-family: Bold;
}
.percentage {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  background: #507cf7;
  border-radius: 10px;
  z-index: 1;
}
.digSHowBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .cameraBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 380px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 25px;
    font-family: Medium;
    font-size: 16px;
    .bkBox {
      width: 172px;
      height: 172px;
      margin: 0 auto;
      position: relative;
      .bk {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .camerBtn {
      width: 180px;
      height: 50px;
      background: #4275f5;
      opacity: 1;
      border-radius: 25px;
      font-family: Medium;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin: 28px auto auto auto;
    }
  }
}
.camera_outer {
  position: relative;
  overflow: hidden;
  // background: url("../../assets/img/user_0608_04.png") no-repeat center;
  background-size: 100%;

  video,
  canvas,
  .tx_img {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .btn_camera {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }

  .bg_r_img {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .img_bg_camera {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    img {
      width: 300px;
      height: 300px;
    }

    .img_btn_camera {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      color: #ffffff;

      .loding_img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.header {
  width: 100%;
  height: 60px;
  background: url('../../assets/listImgs/head_bc@2x.png') 100% 100%;
  padding: 0 20px;
  line-height: 60px;
  font-family: Medium;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 18px;

  .time {
    width: 220px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 31px;
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;
  }
}

.examBanner {
  margin-top: 15px;
  padding: 0 100px;
  display: flex;
  background: rgb(240, 243, 247);
  .examLeft {
    width: 240px;
    height: 850px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    padding: 28px 20px;

    .danBox {
      display: flex;
      flex-wrap: wrap;
      font-family: Medium;
      font-size: 14px;
      .color5 {
        background: #5ad068;
        color: #fff;
        cursor: pointer;
      }
      .color6 {
        background: #f1f3f7;
        color: #8793a4;
        cursor: pointer;
      }
      .color7 {
        background: #4275f5;
        color: #fff;
        cursor: pointer;
      }
      div:nth-child(5n) {
        margin-right: 0 !important;
      }
    }
    .optionTips {
      margin-top: 10px;
      width: 200px;
      height: 50px;
      border: 1px solid #8793a4;
      opacity: 1;
      border-radius: 12px;
      display: flex;
      align-items: center;
      color: #666666;
      font-family: Regular;
      font-size: 14px;
      .yuan {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        opacity: 1;
      }
    }
  }
  .examCenter {
    width: 1220px;
    height: 850px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    padding: 20px;
    .timu {
      position: relative;
      width: 650px;
      max-height: 860px;
      background: #f5f7fb;
      opacity: 1;
      border-radius: 12px;
      overflow-y: auto;
      padding: 54px 25px;
      color: #333333;
      font-family: Medium;
      font-size: 26px;
      .titleTips {
        position: absolute;
        top: 0;
        left: 0;
        width: 72px;
        height: 30px;
        background: #59cc62;
        border-radius: 12px 0px 12px 0px;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
      }
    }
    .timu::-webkit-scrollbar {
      width: 4px;
    }
    .timu::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .timu::-webkit-scrollbar-track {
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
    .xuanx {
      margin-left: 35px;
      .xuan {
        width: 480px;
        min-height: 60px;
        background: #f5f7fb;
        opacity: 1;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        font-size: 22px;
        font-family: Regular;
        cursor: pointer;
        margin-bottom: 20px;
      }
      .seletXuan {
        background: rgba(66, 117, 245, 0.15) !important;
        color: #4275f5 !important;
      }
      .SucceseletXuan {
        background: rgba(105, 175, 121, 0.1) !important;
        color: #69af79 !important;
      }
      .errSeletXuan {
        background: rgba(255, 94, 94, 0.1) !important;
        color: #ff5e5e !important;
      }
      .switchBox {
        display: flex;
        margin-left: 55px;
        .btn {
          width: 160px;
          height: 50px;
          border: 1px solid #4275f5;
          opacity: 1;
          border-radius: 25px;
          cursor: pointer;
          text-align: center;
          line-height: 50px;
          font-family: Medium;
          font-size: 16px;
        }
      }
    }
  }
  .examRight {
    width: 240px;
    height: 850px;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    .fs {
      font-family: Regular;
      font-size: 14px;
      color: #666666;
      line-height: 23px;
      height: 350px;
    }
    .qd {
      margin-left: 20px;
      margin-top: 30px;
      width: 160px;
      height: 50px;
      background: #d3d3d3;
      opacity: 1;
      border-radius: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
    .submit {
      margin-left: 20px;
      margin-top: 42px;
      width: 160px;
      height: 50px;
      background: #fe5f5e;
      box-shadow: 0px 3px 6px rgba(254, 95, 94, 0.31);
      opacity: 1;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
  }
}
</style>
